/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import StickersToolsItems from "./StickersToolsItems.vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { useDtfStore } from "../../store";
import { useStickersStore } from "../../stickers-module";
import "./StickersToolsBorder.scss";

export default function StickersToolsBorder({ artwork, ...restProps }: any) {
  const borderThicknesses = [
    {
      label: "Small",
      value: "small",
      icon: "https://jiffy.imgix.net/gen/sticker-shapes/border-small.png"
    },
    {
      label: "Medium",
      value: "medium",
      icon: "https://jiffy.imgix.net/gen/sticker-shapes/border-medium.png"
    },
    {
      label: "Large",
      value: "large",
      icon: "https://jiffy.imgix.net/gen/sticker-shapes/border-large.png"
    }
  ];

  const store = useDtfStore();
  const stickersStore = useStickersStore();

  function selectedBorderThickness() {
    return artwork?.paddingSize;
  }

  function handleBorderThicknessChange(borderThickness: any) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValuesById({
      id: artwork.id,
      paddingSize: borderThickness
    });
    if (!artwork.isFile && !artwork.isSimulated) {
      const payload = {
        page: "PDP",
        business_line: "Stickers",
        artwork_id: artwork.id,
        border_size: borderThickness,
        is_bg_removed: artwork.removeBackground
      };
      submitDtfEvent("sticker_select_border_size", payload);
      stickersStore.generateStickerImage({
        artwork,
        paddingSize: borderThickness
      });
    }
  }

  return (
    <div {...restProps} className={cn("stickers-tools-border", restProps.className)}>
      <h3 className="stickers-tools-border__title">Select Border Thickness</h3>
      <StickersToolsItems
        value={selectedBorderThickness()}
        items={borderThicknesses}
        onChange={handleBorderThicknessChange}
        data-testid="stickers-tools-items"
      />
    </div>
  );
}
